import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { Delete, Edit, Preview } from "@mui/icons-material";
import { useAuth } from "../../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { SupportService } from "../../api/support.service";
import { useAlert } from "../../hooks/useAlert";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SupportActions = ({ params}) => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const [open, setOpen] = useState(false);

  const handleClickOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleOnProcess = () => {
    deleteSupport(params.id);      
  };
  // refresh
  const refreshPage = () => {
    window.location.reload(true);
  };
  
  // delete support
  const deleteSupport = async (id) => {
    if (!id) return;
    try {
      await SupportService.delete(id, userInfo.jwt); 
      showAlert(t("Delete Support successfully"), "success");
      refreshPage(); 
    } catch (error) {      
      console.log("Error delete", error);
    }
  };

  return (
    <>
      <Box>
        <Tooltip title="View support">
          <IconButton onClick={() => navigate(`/supports/${params.id}`)}>
            <Preview />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("Edit this support")}>
          <IconButton
            onClick={() => navigate(`/supports/${params.id}/edit`)}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("Delete this support")}>
          <IconButton onClick={handleClickOpenDialog}>
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("ATTENTION!")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("Do you really want to delete this support?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={handleCloseDialog}
          >
            {t("CANCEL")}
          </Button>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => handleOnProcess()}
            autoFocus
          >
            {t("YES")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SupportActions;
